import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, Mail, ArrowRight } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const EmailVerificationBanner = () => {
  const { user } = useAuth();

  // Don't show if user is verified or not logged in
  if (!user || user.email_verified !== false) {
    return null;
  }

  return (
    <div className="bg-amber-500/10 border-b border-amber-500/20">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <AlertTriangle className="h-5 w-5 text-amber-400 flex-shrink-0" />
            <p className="text-sm text-amber-200">
              <span className="font-medium">E-posta adresiniz doğrulanmamış.</span>
              {' '}Bazı özellikler kısıtlı olabilir.
            </p>
          </div>
          <Link
            to="/email-dogrulama"
            state={{ email: user.email }}
            className="inline-flex items-center gap-2 px-4 py-1.5 bg-amber-500 text-brand-dark text-sm font-medium rounded-lg hover:bg-amber-400 transition-colors"
          >
            <Mail className="h-4 w-4" />
            Doğrula
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
